import { render, staticRenderFns } from "./ButtonToTopOfPage.vue?vue&type=template&id=22fd82cb"
import script from "./ButtonToTopOfPage.vue?vue&type=script&lang=js"
export * from "./ButtonToTopOfPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports